// [2026-10-29] หน้าหวย noargame — แสดง "ห้องหวย" จากระบบหวยของเรา (tabgamelist state=lotto → rooms)
//   เดิมหน้านี้วาดแบบ "ค่ายเกม" (partner/imagesec) แต่ API ส่งห้องหวยมา → เลยไม่มีอะไรขึ้น
//   กดห้อง → /api/v1/tablauncherlotto (แบบเดียวกับ Starbet999)
import React, { useEffect, useState, useMemo } from 'react';
import instance from "./axios-instance";
import Systems from "./SystemFunction";
import Swal from 'sweetalert2';
import { isMobile } from 'react-device-detect';

const pad = (n) => (n < 10 ? '0' : '') + n;
function countdown(to, now) {
    let s = Math.floor((new Date(to).getTime() - now) / 1000);
    if (!(s > 0)) return null;
    const d = Math.floor(s / 86400); s -= d * 86400;
    const h = Math.floor(s / 3600); s -= h * 3600;
    const m = Math.floor(s / 60); s -= m * 60;
    return (d > 0 ? d + ' วัน ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
}
const fmtTime = (t) => { try { const d = new Date(t); return pad(d.getDate()) + '/' + pad(d.getMonth() + 1) + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes()); } catch (e) { return ''; } };

export default function Lotto({ userid, loginstate }) {
    const [rooms, setRooms] = useState(null);
    const [now, setNow] = useState(Date.now());
    const [group, setGroup] = useState('ทั้งหมด');

    useEffect(() => {
        let alive = true;
        (async () => {
            try {
                const res = await instance.post("/api/v1/tabgamelist", { state: "lotto", System: Systems });
                if (!alive) return;
                const list = res.data && res.data.status === 200 && Array.isArray(res.data.message) ? res.data.message : [];
                setRooms(list.filter((r) => r && r.del !== true && r.isEnabled !== false));
            } catch (e) { if (alive) setRooms([]); }
        })();
        const t = setInterval(() => setNow(Date.now()), 1000);
        return () => { alive = false; clearInterval(t); };
    }, []);

    const groups = useMemo(() => {
        const g = ['ทั้งหมด'];
        (rooms || []).forEach((r) => { const k = r.type || 'อื่นๆ'; if (!g.includes(k)) g.push(k); });
        return g;
    }, [rooms]);

    const list = useMemo(() => {
        const L = (rooms || []).filter((r) => group === 'ทั้งหมด' || (r.type || 'อื่นๆ') === group).map((r) => {
            const open = r.status === 1 && new Date(r.datetimeClose).getTime() > now;
            return { ...r, _open: open };
        });
        // เปิดรับก่อน (ใกล้ปิดก่อน) → ยังไม่เปิด / ปิดรับแล้ว
        return L.sort((a, b) => (b._open - a._open) || (new Date(a.datetimeClose) - new Date(b.datetimeClose)));
    }, [rooms, group, now]);

    const play = async (r) => {
        if (!loginstate || !userid) {
            await Swal.fire({ icon: 'warning', title: 'กรุณาเข้าสู่ระบบก่อนเล่น', confirmButtonText: 'ตกลง' });
            return;
        }
        try {
            const res = await instance.post("/api/v1/tablauncherlotto", { roomid: r.roomid, playerUsername: userid, isMobile, System: Systems, demo: false });
            const launcher = res.data && res.data.status === 200 && res.data.message && res.data.message.launcher;
            if (!launcher) { Swal.fire({ icon: 'error', title: 'Error!', text: 'ขณะนี้เกมมีปัญหากรุณารอซักครู่', confirmButtonText: 'ตกลง' }); return; }
            if (/iPad|iPhone|Macintosh|iPod/.test(navigator.userAgent) && !window.MSStream) window.location.href = launcher.mobile;
            else if (isMobile) window.open(launcher.mobile);
            else window.open(launcher.desktop, '_blank', 'height=1000,width=1000');
        } catch (e) {
            Swal.fire({ icon: 'error', title: 'Error!', text: 'ขณะนี้เกมมีปัญหากรุณารอซักครู่', confirmButtonText: 'ตกลง' });
        }
    };

    return (
        <div className="ltx animated animatedFadeInUp fadeInUp">
            <style>{LTX_CSS}</style>
            <div className="ltx-head">
                <h4 className="ltx-title"><b>หวย</b></h4>
                <small className="ltx-count">{rooms ? list.filter((r) => r._open).length + ' / ' + list.length : ''}</small>
            </div>
            {groups.length > 2 ? (
                <div className="ltx-tabs">
                    {groups.map((g) => (
                        <button key={g} type="button" className={g === group ? 'on' : ''} onClick={() => setGroup(g)}>{g}</button>
                    ))}
                </div>
            ) : null}
            {rooms === null ? <div className="ltx-empty">กำลังโหลด...</div> : !list.length ? <div className="ltx-empty">ยังไม่มีห้องหวยเปิด</div> : (
                <div className="ltx-grid">
                    {list.map((r) => {
                        const cd = r._open ? countdown(r.datetimeClose, now) : null;
                        return (
                            <button type="button" key={r._id || r.roomid} className={'ltx-card' + (r._open ? '' : ' is-off')} onClick={() => play(r)}>
                                <div className="ltx-img">
                                    {r.image ? <img src={r.image} alt="" loading="lazy" /> : <span>🎫</span>}
                                    {r.flagimage ? <img className="ltx-flag" src={r.flagimage} alt="" loading="lazy" /> : null}
                                </div>
                                <div className="ltx-name">{r.name}</div>
                                {r._open ? (
                                    <div className="ltx-cd"><span className="dot" />{cd}</div>
                                ) : (
                                    <div className="ltx-cd off">{r.status === 0 ? 'ยังไม่เปิด' : 'ปิดรับแล้ว'}</div>
                                )}
                                <div className="ltx-time">ปิดรับ {fmtTime(r.datetimeClose)}</div>
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );
}

const LTX_CSS = `
.ltx{padding:6px 4px 90px;color:#fff;max-width:960px;margin:0 auto}
.ltx-head{display:flex;justify-content:space-between;align-items:center;padding:4px 6px 8px}
.ltx-title{margin:0;color:var(--primary,#fbc844);font-size:22px}
.ltx-count{opacity:.7}
.ltx-tabs{display:flex;gap:6px;overflow-x:auto;padding:2px 4px 10px;scrollbar-width:none}
.ltx-tabs::-webkit-scrollbar{display:none}
.ltx-tabs button{flex:0 0 auto;border-radius:999px;padding:6px 14px;font-size:13px;font-weight:700;color:#fff;background:rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.2);white-space:nowrap}
.ltx-tabs button.on{background:var(--primary,#fbc844);color:#111;border-color:var(--primary,#fbc844)}
.ltx-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:8px;padding:0 4px}
@media (min-width:768px){.ltx-grid{grid-template-columns:repeat(4,1fr)}}
@media (min-width:1100px){.ltx-grid{grid-template-columns:repeat(6,1fr)}}
.ltx-card{display:flex;flex-direction:column;align-items:center;gap:3px;padding:8px 6px;border-radius:14px;color:#fff;text-align:center;
  background:linear-gradient(160deg,rgba(255,255,255,.12),rgba(255,255,255,.03));border:1px solid rgba(255,255,255,.16);box-shadow:0 6px 14px rgba(0,0,0,.3);transition:.15s}
.ltx-card:active{transform:scale(.97)}
.ltx-card.is-off{filter:grayscale(1);opacity:.55}
.ltx-img{position:relative;width:64px;height:64px;display:flex;align-items:center;justify-content:center}
.ltx-img img{width:100%;height:100%;object-fit:contain}
.ltx-img .ltx-flag{position:absolute;right:-6px;bottom:-2px;width:24px;height:24px;border-radius:50%;object-fit:cover;border:2px solid rgba(0,0,0,.4)}
.ltx-name{font-size:13px;font-weight:700;line-height:1.2;min-height:32px;display:flex;align-items:center}
.ltx-cd{font-size:13px;font-weight:800;color:var(--primary,#fbc844);display:flex;align-items:center;gap:5px}
.ltx-cd .dot{width:7px;height:7px;border-radius:50%;background:#2ecc71;box-shadow:0 0 6px #2ecc71}
.ltx-cd.off{color:#bbb;font-weight:700}
.ltx-time{font-size:10px;opacity:.65}
.ltx-empty{text-align:center;padding:40px 0;opacity:.7}
`;
